var map = {
	"./anxiang.less": "0Atz",
	"./huarong.less": "8znN",
	"./shaodong.less": "F5g+",
	"./taoyuan.less": "Z8lf",
	"./yueyang.less": "KcPi",
	"./zhuzhou.less": "wmAw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5nlN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common ^\.\/.*\.less$
// module id = 5nlN
// module chunks = 1